import ClubbableLogo from "../../asset/images/Logo(NoBg).webp";
import mobileLogo from "../../asset/images/Header@3x.png";
import "./brending.scss";


function resolveLandingUrl(): string {
  const fromEnv = process.env.REACT_APP_LANDING_URL?.replace(/\/$/, "") ?? "";
  const fromBe =
    process.env.REACT_APP_BE_URL?.split("/app-apis")[0]?.replace(/\/$/, "") ??
    "";
  const fromBuild = fromEnv || fromBe || "https://www.clubbable.com";

  if (typeof window === "undefined") {
    return fromBuild;
  }

  const host = window.location.hostname;
  if (host === "localhost" || host === "127.0.0.1") {
    return fromBuild;
  }

  return window.location.origin.replace(/\/$/, "");
}

export default function Brending() {
  const landingUrl = resolveLandingUrl();

  return (
    <>
      <div className="row logo-bg text-center mobilePosition">
        <a
          href={landingUrl}
          title="Clubbable — visit website"
          className="logo-img d-block mx-auto mt-5"
        >
          <img
            src={ClubbableLogo}
            className="img-responsive img-center lazyloaded logo"
            alt="Logo"
            data-src="{ClubbableLogo}"
          />
        </a>
      </div>
      <div className="row logo-bg text-center p-0 mobileHeaderRow">
        <a
          href={landingUrl}
          title="Clubbable — visit website"
          className="p-0 m-0 logo-img d-block mx-auto mobileLogo mobileHeaderLink"
        >
          <img
            src={mobileLogo}
            className="img-responsive img-center lazyloaded logoMobile mobileHeaderImage"
            alt="Logo"
            data-src="{mobileLogo}"
          />
        </a>
      </div>
    </>
  );
}
